var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49967 11.9167C9.49122 11.9167 11.9163 9.49155 11.9163 6.50001C11.9163 3.50847 9.49122 1.08334 6.49967 1.08334C3.50813 1.08334 1.08301 3.50847 1.08301 6.50001C1.08301 9.49155 3.50813 11.9167 6.49967 11.9167Z",
    stroke: "#6A7282",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33301 6.50001C4.33301 4.48324 5.1088 2.54376 6.49967 1.08334C7.89055 2.54376 8.66634 4.48324 8.66634 6.50001C8.66634 8.51678 7.89055 10.4563 6.49967 11.9167C5.1088 10.4563 4.33301 8.51678 4.33301 6.50001Z",
    stroke: "#6A7282",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08301 6.5H11.9163",
    stroke: "#6A7282",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegion);
export default __webpack_public_path__ + "static/media/region.0fbe603025252b7efd2a294b15bf8e30.svg";
export { ForwardRef as ReactComponent };